import { client } from 'shared';

export function sendCode(channel: string) {
    return client(`api/verification-code/send/`, { body: { channel } });
}
